<div class="layout-footer">
    <div class="grid" style="width: 100%;">
        <div class="col-6">{{'DataStore' | translate | uppercase}}: {{ dataStoreName | uppercase }} | {{memberEmail}}
        </div>
        <div class="col-6 footer-copyright">
            {{date | date : "yyyy"}} © everyDataStore powerd by <a href="https://www.everydatastore.org" target="_blank">everyDataStore GmbH.</a>
        </div>
    </div>
</div>
